import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { formatMoney, formatMoneyInput } from 'helpers/helpers'
import { httpOk, GET, POST, PUT } from 'helpers/api'

const emptyItem = {
	code: '',
	name: '',
	default_price: '',
	is_partner_bonus_enabled: false,
	is_public: true,
	owner_partner_id: null,
	owner_share_percent: '',
	status: 1,
}

function Index() {
	const { t } = useTranslation()
	const [data, setData] = useState([])
	const [modal, setModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState(emptyItem)
	const [partners, setPartners] = useState([])

	async function loadData() {
		const response = await GET('/admin/subscription-services', {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data?.data || [])
		}
	}

	async function getPartners() {
		const response = await GET('/admin/helper/partners')
		if (httpOk(response)) setPartners(response.data || [])
	}

	function toggleModal(bool = false, item = emptyItem) {
		setSelectedItem({
			...emptyItem,
			...item,
			default_price: item.default_price ?? '',
			is_partner_bonus_enabled: !!item.is_partner_bonus_enabled,
			is_public: item.is_public ?? true,
			owner_share_percent: item.owner_share_percent ?? '',
			status: item.status ?? 1,
		})
		setModal(bool)
	}

	async function save(e) {
		e.preventDefault()
		const payload = {
			...selectedItem,
			default_price: String(selectedItem.default_price).replace(/\s/g, ''),
			is_partner_bonus_enabled: !!selectedItem.is_partner_bonus_enabled,
			is_public: !!selectedItem.is_public,
			owner_share_percent: selectedItem.owner_partner_id ? selectedItem.owner_share_percent : 0,
		}

		const response = selectedItem.id
			? await PUT('/admin/subscription-services', payload, { loader: true })
			: await POST('/admin/subscription-services', payload, { loader: true })

		if (httpOk(response)) {
			toggleModal(false)
			loadData()
		}
	}

	useEffect(() => {
		getPartners()
		loadData()
	}, [])

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center mb-0">Доп. услуги подписки [{data.length}]</h4>
				<button className="btn btn-primary" onClick={() => toggleModal(true)}>
					{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: 40 }} className="text-center">#</th>
									<th>Код</th>
									<th>Название</th>
									<th className="text-end">Цена по умолчанию</th>
									<th className="text-center">Бонус агенту</th>
									<th>Автор услуги</th>
									<th className="text-center">В каталоге</th>
									<th className="text-end">Точек</th>
									<th className="text-center">Статус</th>
									<th style={{ minWidth: 40 }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={item.id}>
										<td className="text-center">{index + 1}</td>
										<td>{item.code}</td>
										<td>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="text-end">{formatMoney(item.default_price)}</td>
										<td className="text-center">{item.is_partner_bonus_enabled ? t('yes') : t('no')}</td>
										<td>
											{item.owner_partner_id
												? `${item.owner_name || item.owner_login} — ${Number(item.owner_share_percent)}%`
												: 'Mison'}
										</td>
										<td className="text-center">{item.is_public ? t('yes') : 'Индивидуальная'}</td>
										<td className="text-end">{item.active_pos_count ?? 0}</td>
										<td className="text-center">
											{Number(item.status) === 1 ? t('active') : t('not_active')}
										</td>
										<td className="text-end">
											<button
												type="button"
												className="btn btn-sm btn-outline-primary"
												onClick={() => toggleModal(true, item)}>
												{t('edit')}
											</button>
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr>
										<td colSpan={10} className="text-center text-muted py-4">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<Modal show={modal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{selectedItem.id ? t('edit') : t('create')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={save} autoComplete="off">
						<div className="form-group">
							<label>Код</label>
							<input type="text" className="form-control"
								value={selectedItem.code ?? ''}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									code: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ''),
								})} />
						</div>
						<div className="form-group">
							<label>Название</label>
							<input type="text" className="form-control"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, name: e.target.value })} />
						</div>
						<div className="form-group">
							<label>Цена по умолчанию</label>
							<input type="text" className="form-control"
								value={formatMoneyInput(selectedItem.default_price)}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									default_price: e.target.value.replace(/[^0-9.]/g, ''),
								})} />
						</div>
						<div className="form-check mb-3">
							<input className="form-check-input" type="checkbox" id="isPartnerBonusEnabled"
								checked={!!selectedItem.is_partner_bonus_enabled}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									is_partner_bonus_enabled: e.target.checked,
								})} />
							<label className="form-check-label" htmlFor="isPartnerBonusEnabled">
								Бонус агенту включён
							</label>
						</div>
						<div className="form-group">
							<label>Автор услуги (партнёр)</label>
							<Select
								isClearable
								options={partners}
								value={partners.find((option) => Number(option.id) === Number(selectedItem.owner_partner_id)) || null}
								onChange={(option) => setSelectedItem({
									...selectedItem,
									owner_partner_id: option ? option.id : null,
								})}
								placeholder="Mison"
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name
									? `${option.name} (${option.login})`
									: option.login}
								getOptionValue={(option) => option.id} />
						</div>
						{!!selectedItem.owner_partner_id &&
							<div className="form-group">
								<label>Доля автора, %</label>
								<input type="text" className="form-control"
									value={selectedItem.owner_share_percent ?? ''}
									onChange={(e) => setSelectedItem({
										...selectedItem,
										owner_share_percent: e.target.value.replace(/[^0-9.]/g, ''),
									})} />
							</div>
						}
						<div className="form-check mb-3">
							<input className="form-check-input" type="checkbox" id="isPublic"
								checked={!!selectedItem.is_public}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									is_public: e.target.checked,
								})} />
							<label className="form-check-label" htmlFor="isPublic">
								Показывать в каталоге у клиентов
							</label>
						</div>
						<div className="form-group">
							<label>{t('status')}</label>
							<select className="form-select"
								value={selectedItem.status ?? 1}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									status: Number(e.target.value),
								})}>
								<option value={1}>{t('active')}</option>
								<option value={-1}>{t('not_active')}</option>
							</select>
						</div>
						<div className="d-flex gap-2 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
